import './ComingSoonPage.scss';

import { b2x } from '@b2x/react/src';
import classnames from 'classnames';

import { ComingSoonPageContentType } from '../contentTypes';
import { NewsletterForm } from '../forms/NewsletterForm';
import { Icon, IconName, isIconName } from '../Icon';
import srcLogoRegular from '../images/logo-regular.svg';
import { Page } from './Page';

export const ComingSoonPage = () => {
  const content = b2x.useContent<ComingSoonPageContentType>('COMING_SOON_PAGE_CONTENT');
  const body = content?.body;

  return (
    <Page
      background={body?.pageBackground?.color}
      backgroundAsset={body?.pageBackground?.asset?.type?.at(0) ? body.pageBackground.asset : undefined}
      backgroundSize={body?.pageBackground?.backgroundSize}
      className="coming-soon-page h-100"
      noPaddingBottom
      noPaddingTop
    >
      <div className="py-3 position-relative shadow-sm bg-primary text-center">
        <b2x.Image alt="BB-Skill" src={srcLogoRegular} />
      </div>

      <div className="d-flex align-items-center h-75">
        <b2x.Container>
          <b2x.Row justifyContent={'center'}>
            <b2x.Col size={{ md: 10, xl: 6 }}>
              <div className={classnames('text-center py-4', `text-${body?.copy?.variant}`)}>
                {body?.copy?.title && <h1 className="fw-bold display-1">{b2x.formatHtml(body.copy.title)}</h1>}
                {body?.copy?.content && <p className="h4 fw-light mt-5 mb-4">{b2x.formatHtml(body.copy.content)}</p>}
              </div>
              <div className="my-4">
                <NewsletterForm emailFieldStyle="inputGroup" source="website-footer" />
              </div>
              <div className="mt-5 socials-icon text-white text-center">
                {body?.social?.title && <h2 className="display-2 fw-bold mb-4">{b2x.formatHtml(body.social.title)}</h2>}
                <ul className="list-group list-group-horizontal list-unstyled gap-3 text-white d-flex justify-content-center">
                  {body?.social?.iconsList &&
                    body.social.iconsList.map((item) => {
                      return (
                        item.name &&
                        // item.url &&
                        isIconName(item.name) && (
                          <li key={item.iconTitle}>
                            {/* eslint-disable-next-line react/forbid-elements */}
                            <a className="text-reset" href={item.url} rel="noreferrer" target="_blank">
                              <Icon className="icon-footer" fontSize={44} name={item.name as IconName} />
                            </a>
                          </li>
                        )
                      );
                    })}
                </ul>
              </div>
            </b2x.Col>
          </b2x.Row>
        </b2x.Container>
      </div>
    </Page>
  );
};
